export const L10nFilters = {
  searchTeams: 'Search teams',
  searchSequences: 'Search sequences',
  searchTeamName: 'Search team name',
  searchByNameOrEmail: 'Search by name or email',
  searchDealStages: 'Search deal stages',
  searchPurposes: 'Search purposes',
  searchOutcomes: 'Search outcomes',
  searchCompanies: 'Search companies',
  noResults: 'No purposes found',
  playlists: {
    type: {
      trigger: 'Type',
      title: 'Filter by Playlist type'
    },
    createdBy: {
      trigger: 'Created by'
    }
  },
  teams: 'Teams',
  selected: 'selected',
  total: 'total',
  includeDeactivatedMembers: 'Include deactivated team members',
  includesDeactivatedMembers: 'Includes deactivated team members',
  teamsManagedByMe: 'Teams managed by me',
  teamManagedByMe: 'Team managed by me',
  teamsManagedByMeTooltip:
    'Includes teams you directly manage, plus any subteams within those teams',
  filterByTeam: 'Filter by team',
  filterByLabel: (label: string) => `Filter by ${label}`,
  scoredFor: 'Scored For',
  scoredBy: 'Scored By',
  scoredForTeam: 'Scored For Team',
  scoredByTeam: 'Scored By Team',
  scoredForMember: 'Scored For Member',
  scoredByMember: 'Scored By Member',
  selectSubteams: 'Select subteams',
  deselectSubteams: 'Deselect subteams',
  answered: 'Call was Answered',
  callsOnly: 'Calls Only',
  inbound: 'Inbound',
  outbound: 'Outbound',
  meetingsOnly: 'Meetings Only',
  stageDuring: 'Stage During',
  stageNow: 'Stage Now',
  outcome: 'Outcome',
  saidBy: 'Said By',
  meetingType: 'Meeting Type',
  meetingPrivacy: 'Meeting Privacy',
  videoConferencing: 'Video Conferencing',
  moreFilters: 'More Filters',
  amountNow: 'Amount Now',
  purpose: 'Purpose',
  smartCategory: 'Smart Topic',
  keyword: 'Keyword',
  keywords: 'Keywords',
  resetAllFilters: 'Reset all filters',
  removeFilter: 'Remove Filter',
  removeFilterCallsDashboard:
    "This filter can't be removed while accessing Calls Dashboard",
  removeFilterGlobalSearch:
    "This filter can't be removed while accessing Global Search",
  where: 'where',
  and: 'and',
  is: 'is',
  addFilter: 'Add Filter',
  clearAllFilters: 'Clear All Filters',
  applyFilters: 'Apply Filters',
  dateRange: 'Date Range',
  closeDateAtSnapshotLabel: 'Close date at snapshot',
  closeDateAtSnapshotInfoAriaLabel: 'Close date at snapshot info',
  closeDateAtSnapshotTooltip:
    'Includes deals whose close date was in this period at the time',
  drawerConfirmation: {
    title: 'Discard unsaved changes?',
    content: 'Are you sure you want to discard your unsaved changes?'
  },
  clearAllFiltersConfirmation: {
    title: 'Clear all applied filters?',
    content:
      'Are you sure you want to clear all filters? Unsaved changes will be lost forever.'
  },
  apply: 'Yes',
  dontApply: 'Cancel',
  appliedFilterButton: 'This filter is applied once',
  allFilters: 'All Filters',
  removeGroup: 'Remove Group',
  addFilterGroup: 'Add Filter Group',
  multiInputValuePlaceholder: 'Enter comma separated values',
  enterValueAndPressEnter: 'Type a value and press Enter/Return',
  inputValuePlaceholder: 'Enter text',
  noFiltersFound: 'No filters found',
  noFiltersApplied: 'No filters applied',
  addNewFilter: 'Click to add a new filter',
  noCompaniesFound: 'No Companies Found',
  genericPlaceHolder: 'Select',
  textFieldPlaceholder: 'Enter a value',
  keywordFilterHelperText:
    'Use Said By filter to filter by who mentioned the keywords',
  memberFilterHelperText: 'Use Organizer filter to filter by Organizer',
  applyAndUpdateView: 'Apply filters & update view',
  invalidFilterText:
    'Some of the filter values or filters have been deleted. Please review & save the view with applied filters to see the results.',
  reviewFilterButtonText: 'Review filters',
  deletedFilterLabelPlaceholder: 'Deleted filter',
  crmFilterDeletedErrorMessage:
    'One of your properties does not exist anymore, please apply filters and save view to remove deleted value.',
  filterValueDeletedErrorMessage: {
    prefix: 'Some of the filter values in "',
    postfix:
      '" filter have been removed from your account, please save the current applied filter values to the view.',
    crmPostfix:
      '" property have been removed from your account, please save the current applied filter values to the view.'
  },
  applyAndUpdateViewTooltip:
    'Only saved view owners can update. If deactivated, any admins can update it',
  addFilterNoResultsFound: 'No filters matching for the searched term',
  allFilterButtonTitle: 'All filters'
} as const;

export const CLOSE_DATE_AT_SNAPSHOT_INFO_TOOLTIP_CLASSNAME =
  'max-w-[220px] rounded-md bg-gunmetal px-2 py-1.5 text-xs font-normal leading-5 text-white';
